import insertConnatixAds from './insert-connatix';
import insertSTNAds from './insert-stn';

export default function insertVideoAds(){
  if (window.location.host.includes('dev') || window.location.host.includes('localhost')) { 
    return insertSTNAds();
  }
  insertConnatixAds();
}
